
import { Component, OnInit, HostListener, Renderer2, Inject } from '@angular/core';
import { Router } from '@angular/router';
import { PermissionService } from '../security/permission.service';
import { DOCUMENT } from '@angular/common';
import { hostname } from 'os';

declare var $: any;
declare var location: any;

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
})
export class HomeComponent implements OnInit {

  isModalOpen: boolean = true;
  constructor(private perService: PermissionService, @Inject(DOCUMENT) private _document, private _renderer2: Renderer2
    ) {
  }

  ngOnInit() {
   
    try {
        setTimeout(() => {
          const liveChatDiv = document.getElementById('_proprofs_trk_main_div_');
          const newLocal = 'click';
          if(liveChatDiv){
            liveChatDiv.addEventListener(newLocal, (event) => {
              event.stopPropagation();
              // const modals = document.getElementsByClassName('.modal');
              if ($(".modal:visible").length > 0) {
                $(document).off('focusin.modal');
              }
            });
          }
        }, 2000);
    }
    catch (ex) {
      // console.log(ex);      
    }
  }

  hideModal(){

  }
}




// WEBPACK FOOTER //
// /Users/hrushabhmakwana/Documents/CAM/CreditRepairMenAngular/src/app/home/home.component.ts